// removed by extract-text-webpack-plugin
module.exports = {"block":"Y4uSyWlhla9ZGafZ6wD0G","image":"_185GBAffi5khJBXSg7GOGE","failed":"_2aPF_Q8s5kp7iBlueA_rZ3","failedlabel":"_2gT_I2niOLc-y0NDCOvG67","icon":"_2_T-breYXvk0OXq2eK4yjM","caption":"_2FLt4c4gled90yxB2RPetw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WebcamBlockBody/WebcamBlockBody.module.scss
// module id = 820
// module chunks = 0